import React from 'react';

// "Your Trips" + subtitle counting trips and total saved alternatives.
// See design-handoff.md C.1.

export interface ScreenHeaderProps {
  tripCount: number;
  alternativesTotal: number;
  onNewTrip?: () => void;
}

const ScreenHeader: React.FC<ScreenHeaderProps> = ({ tripCount, alternativesTotal, onNewTrip }) => (
  <header style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 16 }}>
    <div style={{ minWidth: 0 }}>
      <h1
        style={{
          fontFamily: 'Fraunces, Georgia, serif',
          fontSize: 28,
          fontWeight: 600,
          color: '#16241d',
          margin: 0,
        }}
      >
        My Trips
      </h1>
      <p style={{ color: '#6c7872', fontSize: 14, margin: '4px 0 0' }}>
        {tripCount} {tripCount === 1 ? 'trip' : 'trips'} · {alternativesTotal} saved{' '}
        {alternativesTotal === 1 ? 'alternative' : 'alternatives'}
      </p>
    </div>
    {onNewTrip && (
      <button
        onClick={onNewTrip}
        style={{
          flexShrink: 0,
          padding: '8px 14px',
          borderRadius: 999,
          border: 'none',
          background: '#157a55',
          color: '#ffffff',
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        ＋ New trip
      </button>
    )}
  </header>
);

export default ScreenHeader;
